import React from "react";
import { useState } from "react";
import { Grid, Box, CssBaseline } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { GeoPoint } from "firebase/firestore";

import { useAuth } from "../../../../../hooks";
import { useOrganizationContext } from "../../../../../providers/OrganizationAdmin/OrganizationProvider";
import ImagePreviewModal from "../../../../../common/ImagePreviewModal";
import { GAAddDataFieldsSection } from "../../components/components";
import DetailsPageHeader from "../../../../../common/DetailsPageHeader";
import GeneralAdminSidebar from "../../../../../common/GeneralAdminSidebar";
import {
  images,
  mainLayoutStyles,
  showNotification,
  GeneralAdminRoutes,
} from "../../../../../constants";
import {
  addOrganization,
  uploadOrgImageToStorage,
  checkOrgHandleAvailability,
  normalizeHandle,
} from "../../../../../modules/OrgProf/hook/Organizationhook";
import { Toast } from "../../../../../common/alert";
import ConfirmationModal from "../../../../../common/ConfirmationModal";
import { addArea } from "../../../../../modules/AreaManagement/hooks/AreaHook";

export default function GAAddOrganizationContainer() {
  const { handleGetAllOrganizations, allOrganization } =
    useOrganizationContext();

  const { currentUser } = useAuth();
  const navigate = useNavigate();

  const [imagePreviewModal, setImagePreviewModal] = useState(false);
  const [uploadImage, setUploadImage] = useState(null);
  const [uploadImageOP, setUploadImageOP] = useState(null);
  const [editEnabled, setEditEnabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const [cancelModal, setCancelModal] = useState(false);

  const [addOrganizationField, setAddOrganizationField] = useState({
    name: "",
    logoUrl: "",
    logoOP: "",
    id: currentUser.id,
    handle: "",
    orgContact: "",
    phone: "",
    createdAt: new Date(),
    email: "",
    status: "",
    coordinates: null,
    location: "",
    g: null
  });
  // console.log("addOrganizationField", addOrganizationField);

  const handleImagePreviewModalOpen = () => {
    setImagePreviewModal(true);
  };

  const handleImagePreviewModalClose = () => {
    setImagePreviewModal(false);
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      // Org handles must be unique across org handles AND usernames.
      const handleCheck = await checkOrgHandleAvailability(
        addOrganizationField.handle
      );
      if (!handleCheck.available) {
        Toast("error", handleCheck.message);
        return;
      }
      const orgTemp = {
        name: addOrganizationField.name ?? "",
        handle: normalizeHandle(addOrganizationField.handle),
        orgContact: addOrganizationField.orgContact ?? "",
        createdAt: new Date(),
        createdBy: currentUser?.id ?? "",
        orgEmail: addOrganizationField.email ?? "",
        status: addOrganizationField.status.toLowerCase() ?? "",
        phone: addOrganizationField.phone ?? "",
        location: addOrganizationField?.location || "",
        coordinates: new GeoPoint(
          addOrganizationField?.coordinates?._lat || 0,
          addOrganizationField?.coordinates?._long || 0
        ),
        g: {
          geohash: addOrganizationField?.g?.geohash || "",
          geopoint: new GeoPoint(
            addOrganizationField?.coordinates?._lat || 0,
            addOrganizationField?.coordinates?._long || 0
          ),
        },
      };
      if (uploadImage != null) {
        let logoUrl = await uploadOrgImageToStorage(uploadImage?.raw);
        orgTemp.logoUrl = logoUrl;
        orgTemp.originalPhotoName = uploadImage?.raw?.name;
      }
      if (uploadImageOP != null) {
        let logoOP = await uploadOrgImageToStorage(uploadImageOP?.raw);
        orgTemp.logoOP = logoOP;
        orgTemp.originalPhotoNameOP = uploadImageOP?.raw?.name;
      }
      let responseTemp = await addOrganization(orgTemp);
      let areaTemp = {
        organization: responseTemp.id,
        // name: ,
        isActive: true,
        // position: 1,
        createdAt: new Date(),
        quicktales: [],
        createdBy: currentUser?.userName,
      };
      let allAreaTemp = await addArea({
        ...areaTemp,
        name: "All",
        position: 1,
      });
      let nearbyAreaTemp = await addArea({
        ...areaTemp,
        name: "Nearby",
        position: 2,
      });
      await handleGetAllOrganizations();
      showNotification("Organization added successfully.");
      setAddOrganizationField({
        name: "",
        logoUrl: "",
        logoOP: "",
        id: currentUser.id,
        handle: "",
        orgContact: "",
        phone: "",
        createdAt: new Date(),
        email: "",
        status: "",
        coordinates: null,
        location: "",
        g: null
      });
      navigate(-1);
    } catch (error) {
      console.error("Error submitting album data:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleCancelModalOpen = () => {
    setCancelModal(true);
  };
  const handleCancelModalClose = () => {
    setCancelModal(false);
  };
  const handleCancel = () => {
    try {
      setLoading(true);
      handleCancelModalClose();
      navigate(GeneralAdminRoutes.organizations);
      setLoading(false);
    } catch (error) {
      console.log("handleCancel error: ", error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <DetailsPageHeader
        mainTitle={`Add Organization`}
        bgColor="#fff"
        buttonText={"Edit"}
        editEnabled={true}
        onCancelClick={() => handleCancelModalOpen()}
        cancelButton={true}
        submitButtonText={"Save"}
        handleSave={() => handleSubmit()}
        loading={loading}
      />
      <GeneralAdminSidebar />

      <Grid container style={{ ...mainLayoutStyles, background: "#fff" }}>
        <Grid container direction={"column"} style={subContainerStyles}>
          {/*Data card/container section*/}
          <GAAddDataFieldsSection
            addOrganizationField={addOrganizationField}
            setAddOrganizationField={setAddOrganizationField}
            handleImagePreviewModalOpen={handleImagePreviewModalOpen}
            editEnabled={editEnabled}
            uploadImage={uploadImage}
            setUploadImage={setUploadImage}
            uploadImageOP={uploadImageOP}
            setUploadImageOP={setUploadImageOP}
            setEditEnabled={setEditEnabled}
          />
          {/*Report card/container section*/}

          <ImagePreviewModal
            modalOpen={imagePreviewModal}
            handleClose={handleImagePreviewModalClose}
            image={
              uploadImage != null && uploadImage.preview
                ? uploadImage.preview
                : images.tableDummyImage
            }
          />
          {/* <Grid container justifyContent={"center"} alignItems={"center"}>
            <Button
              variant="contained"
              style={buttonStyles}
              //   onClick={() => {}}
            >
              Add QuickTales
            </Button>
          </Grid> */}
        </Grid>
      </Grid>

      <ConfirmationModal
        open={cancelModal}
        onClose={handleCancelModalClose}
        onConfirm={handleCancel}
        title={`Are you sure you want to cancel adding a new organization? Any changes will be discarded.`}
      />
    </Box>
  );
}

const subContainerStyles = {
  paddingLeft: 30,
  paddingRight: 30,
  marginTop: 50,
};

const buttonStyles = {
  //   marginLeft: "auto",
  textTransform: "none",
  background: "#00A7CD",
  fontSize: 15,
  fontWeight: 500,
  marginTop: 100,
  fontFamily: "Avenir Book, sans-serif",
};
